exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".token.cr,.token.lf,.token.space,.token.tab:not(:empty){position:relative}.token.cr:before,.token.lf:before,.token.space:before,.token.tab:not(:empty):before{color:grey;opacity:.6;position:absolute}.token.tab:not(:empty):before{content:\"\\21E5\"}.token.cr:before{content:\"\\240D\"}.token.crlf:before{content:\"\\240D\\240A\"}.token.lf:before{content:\"\\240A\"}.token.space:before{content:\"\\B7\"}", ""]);

// exports
